const FormDateInput = ({
  label,
  name,
  placeholder,
  register,
  error,
  required = false,
  withTime = false,
  className = "",
  ...rest
}) => {
  const inputType = withTime ? "datetime-local" : "date";
  const defaultPlaceholder = withTime
    ? "dd-mm-yyyy hh:mm am/pm"
    : "dd-mm-yyyy";

  return (
    <div className={`mb-6 ${className}`}>
      {label && (
        <label
          htmlFor={name}
          className="block text-sm font-medium text-[#636363] mb-1"
        >
          {label}
          {required && <span className="text-red-500">*</span>}
        </label>
      )}
      <input
        type={inputType}
        id={name}
        name={name}
        required={required}
        placeholder={placeholder || defaultPlaceholder}
        className="
          w-full rounded-md border border-[#CACACA] px-4 py-2 bg-[#F6F6F6] 
          text-[#1100EF] text-sm placeholder:text-[#858585] focus:text-[#000]
          focus:outline-none focus:ring-2 focus:ring-blue-500"
        {...(register && name ? register(name) : {})}
        {...rest}
      />
      {error && <p className="text-sm text-red-500 mt-1">{error.message}</p>}
    </div>
  );
};

export default FormDateInput;